// extracted by mini-css-extract-plugin
export default {"buttonContainer":"cu-0-","alignToEdge":"I0u1c","buttonIcon":"OsODp","buttonCaption":"yR21y","buttonSpacer":"Gos5f"};